module.exports = __webpack_public_path__ + "img/Friction-Machine-min.15dc25ce.png";